export default __webpack_public_path__ + "static/media/13_Small_Chonky_Yellow.394e0df3.png";